<template>
  <div ref="lastArticlesHeader" class="lastArticlesContainer">
    <v-toolbar class="categoriesHeader" elevation="0"
    >
      <v-icon @click="goBack">
        mdi-chevron-left
      </v-icon>


      <v-toolbar-title class="pageTitle">
        Gemerkte Artikel
      </v-toolbar-title>
    </v-toolbar>
    <v-divider class="headerDivider"/>
    <div class="contentWrapper" ref="contentWrapper">
      <product-list :renderData="renderData" :reorder="true" @valueChanged="valueChanged" v-if="!isLoading"/>
      <div class="textSize__16 text-align-left" v-if="!isLoading && renderData.products.length === 0">
        Du hast leider keine Artikel auf Deiner Merkliste.
        Um Artikel hinzuzufügen, klicke in der Detailansicht von Artikeln einfach auf den "Merken"-Button
      </div>
      <v-container class="lastArticlesWrapper loading" v-if="isLoading">

        <v-row
            class="articleCardRow"
        >
          <v-col cols="12"
                 class="articleCardCol"
                 v-for="index in 4"
                 :key="index"
          >
            <v-card class="articleCard"
                    elevation="0"
                    v-bind:class="{cartItem: renderData.cart && !renderData.order}"
                    light
            >
              <v-list-item three-line class="skeletonWrapper__li">
                <v-skeleton-loader class="skeletonAvatar" type="avatar">

                </v-skeleton-loader>

                <v-list-item-content>
                  <v-container>
                    <v-row class="articleCard__details">
                      <v-col cols="12"
                             class="articleNameSmall"
                      >
                        <v-skeleton-loader type="text"/>
                      </v-col>
                      <div class="articleAdditionalInfoWrapper">
                        <v-col cols="12" class="pb-0 pt-2">
                          <v-skeleton-loader type="text"/>
                        </v-col>
                      </div>
                      <v-col cols="12" class="articleStatus">
                        <v-skeleton-loader type="text"/>
                      </v-col>
                      <v-col cols="12" class="pa-0 articlePriceMain">
                        <v-skeleton-loader type="text"/>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <div class="bottomFiller"/>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {mapActions, mapGetters, mapMutations, mapState} from 'vuex'
import ProductList from "@/app/productListing/productList";
import router from "@/router";
export default {
  name: "watchList",
  components: {ProductList},
  data:() => {
    return {
      renderData: {cart: false, category: true, watchlist: true, products: [], name: 'Gemerkte Artikel'},
      isLoading: true,
    }
  },

  methods: {
    ...mapActions({
      setCategoryBreadcrumbs: 'setCategoryBreadcrumbs',
      setHeaderVisibility: 'setHeaderVisibility',
      updateWatchlist: 'updateWatchlist'
    }),

    ...mapMutations({
      setCurrentPosition: 'setCurrentPosition'
    }),

    goBack() {
      router.go(-1)
    },
    valueChanged (value) {
      let params = {
        watchlist: value
      }
      this.updateWatchlist(params)
    },
  },

  computed: {
    ...mapGetters({
      isLogged: 'isLogged'
    }),

    ...mapState({
      currentPosition: 'currentPosition'
    })
  },

  created() {
    this.setHeaderVisibility(false)
    axios.get('/api/watchlist')
        .then((result) => {
          this.renderData.products = result.data
        })
        .finally(() => this.isLoading = false)
  },

  beforeRouteLeave(to, from, next) {
    if(to.name === 'Artikeldetails') {
      this.setCurrentPosition(this.$refs["contentWrapper"].scrollTop)
    }
    next()
  },

  watch: {
    isLoading: {
      handler(loadingState) {
        if(!loadingState) {
          this.$nextTick(function () {
            if(this.currentPosition !== null) {
              this.$refs["contentWrapper"].scrollTo(0, this.currentPosition)
              this.setCurrentPosition(null)
            }
          })
        }
      }
    }
  }
}
</script>

<style scoped>
.lastArticlesWrapper.loading .row.articleCardRow {
  display: unset;
}
</style>
